/**
 * Download a text file via the classic `<a download>` pattern.
 */
export async function downloadTextFile(filename: string, content: string): Promise<void> {
  const blob = new Blob([content], { type: 'text/plain; charset=utf-8' });
  const url = globalThis.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  globalThis.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

/** Open a URL in a new browser tab. */
export async function openUrl(url: string): Promise<void> {
  window.open(url, '_blank', 'noopener,noreferrer');
}
